import { HeatmapLayer as L7HeatmapLayer } from '@antv/l7-composite-layers';
import { forwardRef, memo, useImperativeHandle } from 'react';
import { useCreateLayer, useLayerEvent } from "../../hooks";
export var HeatmapLayer = /*#__PURE__*/memo( /*#__PURE__*/forwardRef(function HeatmapLayer(props, ref) {
  var layerRef = useCreateLayer(L7HeatmapLayer, props);
  useLayerEvent(layerRef.current, props);
  useImperativeHandle(ref, function () {
    return layerRef.current;
  });
  return null;
}));